import { render, staticRenderFns } from "./CustomersReportDetail.vue?vue&type=template&id=12f63cd7&scoped=true&"
import script from "./CustomersReportDetail.vue?vue&type=script&lang=js&"
export * from "./CustomersReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomersReportDetail.vue?vue&type=style&index=0&id=12f63cd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f63cd7",
  null
  
)

export default component.exports